import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";

/**
 * CarrouselText: Muestra frases completas una por una como un carrusel visual.
 * @param {Object} props
 * @param {string[]} props.words - Lista de frases a mostrar.
 * @param {number} [props.delay=4000] - Tiempo de espera entre cada frase.
 * @param {boolean} [props.useGradient=true] - Si se usa estilo con degradado o texto blanco.
 */
const CarrouselText = ({ words, delay = 4000, useGradient = true }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % words.length);
    }, delay);
    return () => clearTimeout(timeout);
  }, [currentIndex, words.length, delay]);

  const textStyle = useGradient
    ? "text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-pink-400 to-red-500"
    : "text-white";

  return (
    <Fade key={currentIndex} duration={800} triggerOnce>
      <p
        className={`max-w-4xl mx-auto text-center font-medium drop-shadow-lg px-4
          text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl ${textStyle}`}
      >
        {words[currentIndex]}
      </p>
    </Fade>
  );
};

export default CarrouselText;
